import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { DownloadButton } from "~/components/AssetModalV2/Content/Footer/components/DownloadButton";
import { usePublicDownloadOptions } from "~/components/AssetModalV2/hooks/usePublicDownloadOptions";
export const PublicDownloadButton = /*#__PURE__*/ memo(()=>{
    const options = usePublicDownloadOptions();
    return /*#__PURE__*/ _jsx(DownloadButton, {
        options: options
    });
});
PublicDownloadButton.displayName = "PublicDownloadButton";
